import { defineStore } from 'pinia';
import notificationWrapper from '@/utils/helpers/notificationWrapper';
import { useProjectStore } from './projectStore';

export const useDeclarationStore = defineStore('declaration', {
  state: () => ({
    declaration: [],
    declarationLoading: false,
    declarationCreated: false,
  }),

  actions: {
    async getDeclaration() {
      this.declarationLoading = true;
      try {
        const projectStore = useProjectStore();
        const data = await window.appConnector.getDeclaration(projectStore.projectIdSelected);
        if (data?.declaration) {
          this.declarationCreated = true;
          this.declaration = data.declaration;
          this.declarationLoading = false;
        }
      } catch (error) {
        this.declarationLoading = false;
        if (error && error.status === 404) {
          return;
        }
        notificationWrapper();
        throw error;
      }
    },

    async postDeclaration(declaration: any) {
      this.declarationLoading = true;
      try {
        const projectStore = useProjectStore();
        const data = await window.appConnector.postDeclaration(projectStore.projectIdSelected, { declaration });
        if (data?.declaration) {
          this.declarationCreated = true;
          this.declaration = data.declaration;
          notificationWrapper('success', 'POST_DECLARATION');
          this.declarationLoading = false;
        }
      } catch (error) {
        this.declarationLoading = false;
        notificationWrapper();
        throw error;
      }
    },

    async patchDeclaration(declaration: any) {
      this.declarationLoading = true;
      try {
        const projectStore = useProjectStore();
        const data = await window.appConnector.patchDeclaration(projectStore.projectIdSelected, { declaration });
        if (data?.declaration) {
          this.declaration = data.declaration;
          notificationWrapper('success', 'PATCH_DECLARATION');
          this.declarationLoading = false;
        }
      } catch (error) {
        notificationWrapper();
        this.declarationLoading = false;
        throw error;
      }
    },
  },
});
